import React from 'react';
import SelectStyled from './select.styled';

export const ANY_OPTION_VALUE = '*';
const ANY_OPTION_LABEL = 'Any';

// Presentational multi-select with an injected "Any" option (NR-1464 spec 5.6).
// Receives the FULL option list from the parent (never scoped by cycle - there
// is no reliable cycle->option link, spec section 3) and works in antd's array
// mode. Mutually-exclusive logic (R6): picking a specific option clears "Any";
// picking "Any" clears specifics; an empty selection falls back to "Any". The
// parent normalizes a sole ['*'] to the scalar '*' when writing the entry.
const DuesOptionSelector = ({
  value = [ANY_OPTION_VALUE],
  onChange,
  options = [],
  placeholder = 'Any',
  loading = false,
  disabled = false,
}) => {
  const { Option } = SelectStyled;

  const handleChange = selected => {
    // Empty selection -> fall back to "Any".
    if (!selected.length) {
      return onChange([ANY_OPTION_VALUE]);
    }
    const anyWasSelected = value.includes(ANY_OPTION_VALUE);
    const anyNowSelected = selected.includes(ANY_OPTION_VALUE);
    // User just added "Any" -> collapse to Any only.
    if (anyNowSelected && !anyWasSelected) {
      return onChange([ANY_OPTION_VALUE]);
    }
    // Otherwise a specific option is in play -> strip "Any".
    return onChange(selected.filter(v => v !== ANY_OPTION_VALUE));
  };

  return (
    <SelectStyled
      mode="multiple"
      placeholder={placeholder}
      showSearch
      // Selections render one per row below the input (NR-1464 spec section
      // 12 item 2); keep the input itself tag-free so long option names
      // cannot break its layout. The sole "Any" still reads as "Any".
      maxTagCount={0}
      maxTagPlaceholder={omitted =>
        omitted.length === 1 && omitted[0].value === ANY_OPTION_VALUE
          ? ANY_OPTION_LABEL
          : `${omitted.length} selected`
      }
      filterOption={(input, option) =>
        String(option?.children ?? '')
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      value={value}
      loading={loading}
      disabled={disabled}
      onChange={handleChange}
      dropdownMatchSelectWidth={false}
      style={{ width: '240px' }}
    >
      <Option key={ANY_OPTION_VALUE} value={ANY_OPTION_VALUE}>
        {ANY_OPTION_LABEL}
      </Option>
      {options.map(({ value: optionValue, label }) => (
        <Option key={optionValue} value={optionValue}>
          {label}
        </Option>
      ))}
    </SelectStyled>
  );
};

export default DuesOptionSelector;
